<mat-card #dropdown>
	<div *ngFor="let item of items; let i = index" class="item" (mousedown)="selectItem()" (mouseenter)="currentItemIndex = i" (mouseleave)="currentItemIndex = -1"
	 [class.highlight]="(i === currentItemIndex)" [attr.cy-elm]="item[displayBy] + ' option' | kebab" cy-elm="autocomplete-dropdown">
		{{ item[displayBy] }}
	</div>
</mat-card>
